DealLazyLoader = window.DealLazyLoader =
  sleepyLoadImages: () ->
    $('.sleepy-load').lazyload({skip_invisible: false})

  init: (payload, done) ->
    $(document.body).on 'modal-open', (e, data) ->
      $('#' + data.id).find('.lazy-load').lazyload()

    # lazyLoad images that were not yet available during the document.ready event. e.g. carousel thumbnails
    $(window).load ->
      Groupon.Utils.lazyLoadImages({skip_invisible: false})
      DealLazyLoader.sleepyLoadImages()

    done()

module.exports = DealLazyLoader



// WEBPACK FOOTER //
// ./modules/deal/frontend/deal_lazy_loader.coffee